import React from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Section from "./Section";
import FeatureText from "./FeatureText";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: `0 ${theme.spacing(3)}px`,
  },
}));

function HeroSection3(props) {
  const classes = useStyles();

  return (
    <Section
      bgColor={props.bgColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          background:
            "radial-gradient(45% 55% at 12% 50%, rgba(244,81,30,0.12), transparent 70%)",
        }}
      />
      <Container className={classes.container}>
        <Grid container alignItems="center" spacing={6} direction="row-reverse">
          <Grid item xs={12} md={6}>
            <Box textAlign={{ xs: "center", md: "left" }}>
              <FeatureText
                icon={props.icon}
                title={props.title}
                subtitle={props.subtitle}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className="relative mx-auto w-full max-w-[520px]">
              <div
                aria-hidden="true"
                className="absolute -inset-4 rounded-3xl opacity-50 blur-2xl"
                style={{
                  background:
                    "radial-gradient(circle at 70% 30%, rgba(124,77,255,0.35), transparent 65%), radial-gradient(circle at 20% 70%, rgba(244,81,30,0.35), transparent 65%)",
                }}
              />
              <figure className="group relative overflow-hidden rounded-3xl border border-white/10 bg-white/5 shadow-2xl transition duration-500 hover:-translate-y-1 hover:border-white/25">
                <img
                  src={props.image}
                  alt="illustration"
                  loading="lazy"
                  className="block h-auto w-full transition duration-700 group-hover:scale-[1.03]"
                />
              </figure>
            </div>
          </Grid>
        </Grid>
      </Container>
    </Section>
  );
}

export default HeroSection3;
